import React, { useEffect, useMemo, useState } from 'react';
import { Box, Flex, Caption, Icon, Checkmark, Cross, Calendar, Alert } from '@xceedsrl/jukebox';
import { useTranslation } from '../i18n/I18nProvider';
var CheckoutInput = 'input';
function allowInputEvents(e, allowPaste) {
  if (allowPaste === void 0) {
    allowPaste = false;
  }
  if (!allowPaste) e.preventDefault();
}
function Input(_ref) {
  var error = _ref.error,
    value = _ref.value,
    handleBlur = _ref.handleBlur,
    handleChange = _ref.handleChange,
    name = _ref.name,
    dataType = _ref.dataType,
    displayName = _ref.displayName,
    required = _ref.required,
    disabled = _ref.disabled,
    style = _ref.style,
    styleCheck = _ref.styleCheck,
    allowPaste = _ref.allowPaste;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    isValid = _useState[0],
    setValid = _useState[1];
  var isFirefox = navigator.userAgent.search('Firefox') !== -1;
  var isDate = dataType.toLowerCase().includes('date');
  var isAndroid = navigator.userAgent.toLowerCase().includes('android');
  var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
  var emailValidator = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  var Check = useMemo(function () {
    return React.createElement(Box, {
      width: "auto",
      position: "absolute",
      style: styleCheck,
      alignSelf: "center",
      right: 18
    }, React.createElement(Icon, {
      fontSize: isValid ? 16 : 14,
      color: isValid ? 'feeling.positive' : 'feeling.negative'
    }, isValid ? React.createElement(Checkmark, null) : React.createElement(Cross, null)));
  }, [isValid]);
  useEffect(function () {
    if (dataType.toLowerCase() === 'email') {
      setValid(emailValidator.test(value) && !error);
    } else {
      var newValidity = !error && !!value;
      if (isValid !== newValidity) {
        setValid(newValidity);
      }
    }
  }, [error, value]);
  var handleKeyDown = function handleKeyDown(event) {
    if (name.toLowerCase().includes('mail') && event.key === ' ') {
      event.preventDefault();
    }
    if (name.toLowerCase().includes('name') && event.key === ' ' && (event.target.selectionStart === 0 || event.target.value.charAt(event.target.selectionStart - 1) === ' ')) {
      event.preventDefault();
    }
  };
  var setDataType = function setDataType(event) {
    if (event.target.type !== dataType) event.target.type = dataType;
  };
  var _onBlur = function onBlur(event) {
    if (dataType === 'date' && !value) {
      event.target.type = 'text';
    }
    handleBlur(event);
  };
  return React.createElement(Flex, {
    position: "relative",
    className: "adyen-checkout__wrapper"
  }, React.createElement(CheckoutInput, {
    key: name,
    "data-testid": "input--" + name,
    type: dataType === 'date' ? 'text' : dataType,
    name: name,
    value: value,
    onTouchStart: function onTouchStart(event) {
      return setDataType(event);
    },
    onChange: function onChange(event) {
      return handleChange(event);
    },
    onKeyDown: function onKeyDown(event) {
      return handleKeyDown(event);
    },
    onBlur: function onBlur(event) {
      return _onBlur(event);
    },
    placeholder: displayName,
    required: required,
    disabled: disabled,
    className: "adyen-checkout__input " + (disabled ? 'adyen-checkout__input--disabled' : '') + "\n          " + (isDate ? 'adyen-checkout__date' : '') + "\n          " + (isAndroid && isDate && !value ? 'adyen-checkout__empty-date__android ' : '') + "\n          " + (!value && isDate ? 'adyen-checkout__empty-date' : '') + "\n          " + (isFirefox || isSafari ? 'adyen-checkout__input-pointer' : '') + "\n          " + (isMobile ? 'adyen-checkout__input-mobile' : '') + "\n          ",
    onPaste: function onPaste(e) {
      allowInputEvents(e, allowPaste);
    },
    onCopy: allowInputEvents,
    onCut: allowInputEvents,
    onDrag: allowInputEvents,
    onDrop: allowInputEvents,
    onFocus: function onFocus(event) {
      return setDataType(event);
    },
    autoComplete: "off",
    pattern: dataType === 'numeric' ? 'd*' : null,
    style: style
  }), (isAndroid || isSafari) && isDate && React.createElement(Box, {
    position: "absolute",
    right: value ? 41 : 18,
    alignSelf: "center",
    pointerEvents: "none"
  }, React.createElement(Icon, {
    position: "absolute",
    fontSize: 16,
    color: "brandDark"
  }, React.createElement(Calendar, null))), !required && !value && React.createElement(Box, {
    position: "absolute",
    bottom: "3px",
    right: 1
  }, React.createElement(Caption, null, t('optional'))), value && Check, isDate && !!error && !!value && React.createElement(Box, {
    position: "absolute",
    bottom: "-60%",
    style: {
      whiteSpace: 'nowrap'
    }
  }, React.createElement(Alert, {
    color: "feeling.negative"
  }, t('birthdateMaxError_adyen'))));
}
export default React.memo(Input);